// Interface für Exercise (falls nicht bereits importiert)
export interface Exercise {
  id: string;
  name: string;
}

// 🔹 Mapping von Wettkampfklassen-Namen zu erlaubten Übungen
export const EXERCISE_RULES: Record<string, string[]> = {
  // Elite-Klassen
  "01 - Jugendturnerinnen 2014 und jünger": ["M5", "M6", "M7", "W11"],
  "02 - Jugendturner 2014 und jünger":  ["M5", "M6", "M7", "W11"],
  "03 - Jugendturnerinnen 2013/2012" : ["W13"],
  "04 - Jugendturner 2013/2012": ["W13"],
  "05 - Jugendturnerinnen 2011/2010": ["W13"],
  "06 - Jugendturner 2011/2010": ["W13"],
  "07 - Turnerinnen 2009 und älter": ["Kür"],
  "08 - Turner 2009 und älter": ["Kür"],
  // Basis-Klassen
  "11 - Bambini w (2017 und jünger)": ["P3", "M0", "M1", "M2", "M3", "M4"],
  "12 - Bambini m (2017 und jünger)": ["P3", "M0", "M1", "M2", "M3", "M4"],
  "13 - Jugendturnerinnen 2016 - 2014": ["M0", "M1", "M2", "M3", "M4", "P9"],
  "14 - Jugendturner 2016 - 2014": ["M0", "M1", "M2", "M3", "M4", "P9"],
  "15 - Jugendturnerinnen 2013 - 2010": ["M1", "M2", "M3", "M4", "P9"],
  "16 - Jugendturner 2013 - 2010": ["M1", "M2", "M3", "M4", "P9"],
  "17 - Turnerinnen 2009 und älter": ["Kür"],
  "18 - Turner 2009 und älter": ["Kür"],
  // Fallback
  "default": [
    "P3", "M0", "M1", "M2", "M3", "M4", "P9",
    "M5", "M6", "M7", "W11", "W13", "W17", "Kür"
  ]
};

// 🔹 Standard-Übungen falls nicht im Competition-Schema definiert
export const DEFAULT_EXERCISES: Exercise[] = [
  { id: 'P3', name: 'P3'},
  { id: 'M0', name: 'M0'},
  { id: 'M1', name: 'M1'},
  { id: 'M2', name: 'M2'},
  { id: 'M3', name: 'M3'},  
  { id: 'M4', name: 'M4'},
  { id: 'P9', name: 'P9'},
  { id: 'M5', name: 'M5'},
  { id: 'M6', name: 'M6'},
  { id: 'M7', name: 'M7'},
  { id: 'W11', name: 'W11'},
  { id: 'W13', name: 'W13'},
  { id: 'W17', name: 'W17'},
  { id: 'Kür', name: 'Kür'}  
];

// 🔹 Hilfsfunktion: Ermittle erlaubte Übungen basierend auf Wettkampfklassen-Name
export const getAllowedExercisesByClassName = (competitionGroupName: string): Exercise[] => {
  const normalizedName = competitionGroupName.toLowerCase().trim();
  
  let allowedExerciseIds = EXERCISE_RULES[competitionGroupName];
  
  if (!allowedExerciseIds) {
    for (const [ruleName, exercises] of Object.entries(EXERCISE_RULES)) {
      if (ruleName !== "default" && normalizedName.includes(ruleName.toLowerCase())) {
        allowedExerciseIds = exercises;
        break;
      }
    }
  }
  
  if (!allowedExerciseIds) {
    allowedExerciseIds = EXERCISE_RULES["default"];
  }
  
  return DEFAULT_EXERCISES.filter(exercise => 
    allowedExerciseIds.includes(exercise.id)
  );
};

// 🔹 Hilfsfunktion: Ermittle erlaubte Übung-IDs als String-Array
export const getAllowedExerciseIdsByClassName = (competitionGroupName: string): string[] => {
  const normalizedName = competitionGroupName.toLowerCase().trim();
  
  let allowedExerciseIds = EXERCISE_RULES[competitionGroupName];
  
  if (!allowedExerciseIds) {
    for (const [ruleName, exercises] of Object.entries(EXERCISE_RULES)) {
      if (ruleName !== "default" && normalizedName.includes(ruleName.toLowerCase())) {
        allowedExerciseIds = exercises;
        break;
      }
    }
  }
  
  return allowedExerciseIds || EXERCISE_RULES["default"];
};